<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <!-- <ion-buttons slot="end">
        <ion-button class="pill next-pill-button" @click="skip">
          Skip
        </ion-button>
      </ion-buttons> -->
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        <div class="auth-header">
          <div class="auth-heading">
            <h1>Gender</h1>
            <span></span>
          </div>
          <div class="brand-icon">
            <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
          </div>
        </div>
        <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('userForm')">
          <div class="form_text">
            <div class="text">
              Please select your gender for Super and AHPRA verification
            </div>
          </div>
          <el-form-item class="no-scroll" prop="gender" :required="true">
            <el-select class="covid-cert-select" style="width: 100%" v-model="formsData.userForm.gender.value"
              placeholder="Please select your gender">
              <el-option label="Male" :value="1"></el-option>
              <el-option label="Female" :value="2"></el-option>
              <el-option label="Other" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="button_submit button_submit mb0">
            <el-button class="submit" type="blue" @click="goNext('userForm')" :disabled="formsData.userForm.disabled">
              Continue <i class="el-icon-right"></i>
            </el-button>
          </el-form-item>
        </el-form>
        <div class="background-circles">
                    <div class="circle circle-2"></div>
                    <div class="circle circle-1"></div>
                    <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
                </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, inject, } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";

import { useRoute, useRouter } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import { ElMessageBox } from "element-plus";
import SvgIcon from '@/components/Svg/SvgIcon.vue';


export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const userData = $store.getters.GET_USER_DATA;

    const formsDataArray = {
      userForm: {
        ref: null,
        gender: {
          value: userData.gender || null,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "gender",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };

    const goBack = async () => {
      await $store.dispatch("getAuthPageBack");
      $router.push({
          name: 'onboard_birthday',
      })
    };

    const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    await $store.dispatch("addAuthPageBack", $route.name);
                    $router.push({
                        name: "onboard_ahpra",
                    });
                } catch (error) {
                    console.log(error);
                }
            })();
        };

    const goNext = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              console.log(getFormValues(formName))
              await $store.dispatch("SAVE_USER_DATA", getFormValues(formName));
              $router.push({
                name: "onboard_ahpra",
              });
            } catch (error) {
              console.log(error);
            }
          })();
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };

    onMounted(() => {
      setPageClassGlobal("global_onboard_internal_page");
      setFormRefs();
      checkFormValidation("userForm", false);
    });

    const {
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      formsData,
      goBack,
      goNext,
      skip
    };
  },
};
</script>
